<template>
  <div class="add-participants">
    <div class="add-participants__main">
      <div class="add-participants__drag-block">
        <div class="add-participants__draggable-blocked">
          <div class="add-participants__draggable-blocked-item">
            <div class="add-participants__responsible-text">
              <div class="add-participants__vacancy-name">Новый отклик</div>
              <div class="add-participants__responsible-text-name">{{ owner }}</div>
            </div>
          </div>
        </div>
        <div class="add-participants__employees">
          <div v-for="element in selectedEmployeesList" :key="selectedRoute">
            <div v-if="element?.stage === 'medical'" class="add-participants__documents">
              <div class="add-participants__responsible-text">
                <div class="add-participants__vacancy-name">Медицинская проверка</div>
                <div class="add-participants__responsible-text-name">{{ owner }}</div>
              </div>
            </div>

            <div v-else-if="element?.stage === 'approving'" class="add-participants__documents">
              <div class="add-participants__responsible-text">
                <div class="add-participants__vacancy-name">Согласовант</div>
                <div class="add-participants__responsible-text-name">{{ element.responsible.full_name }}</div>
              </div>
            </div>

            <div v-else-if="element?.stage === 'documents'" class="add-participants__documents">
              <div class="add-participants__responsible-text">
                <div class="add-participants__vacancy-name">Запрос документов</div>
                <div class="add-participants__responsible-text-name">{{ owner }}</div>
              </div>
            </div>

            <div v-else-if="element?.stage === 'tickets'" class="add-participants__documents">
              <div class="add-participants__responsible-text">
                <div class="add-participants__vacancy-name">Покупка билетов</div>
                <div class="add-participants__responsible-text-name">{{ element.responsible.full_name }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {onMounted, ref} from "vue";
import {useStore} from "vuex";

const props = defineProps({
  modelValue: Object,
  vacancy: Object,
  owner: String,
  selectedRoute: Number,
})

const showModalBuyingTickets = ref(false)

const selectedEmployeesList = ref([])
const store = useStore()

const addStep = (step) => {
  selectedEmployeesList.value.push({stage: step})
}

onMounted(() => {
  selectedEmployeesList.value = [...props.modelValue]
  // if ((props?.modelValue?.routes && Object.entries(props?.modelValue?.routes).length) ) {
  //   organizeReadSteps(props.modelValue.approvalRoute)
  // } else {
  //
  // }
})
</script>

<style scoped lang="scss">
.add-participants {
  margin-top: 24px;
  background-color: #fff;
  border-radius: 14px;
  box-shadow: 1.92px 1.92px 7.68px 0px #0000000A;
  padding: 24px 18px 4px 18px;

  &__head {
    display: flex;
    margin-bottom: 20px;
    padding-right: 40px;
  }

  &__add-button {
    display: block;
    margin-right: 24px;
    padding: 8px 0;
    height: 35px;
    font-size: 16px;
    font-weight: 400;
    line-height: 19.36px;
    border: none;
    background-color: transparent;
    color: #0086B2;
    cursor: pointer;
  }

  &__add-icon {
    position: relative;
    margin-left: 8px;
    left: -8px;
  }


  &__draggable-blocked-item {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    width: 100%;
    height: 48px;
    color: $dark;
    font-size: 14px;
    font-weight: 400;
    line-height: 16.94px;
    font-size: 14px;
    font-weight: 400;
    line-height: 16.94px;
  }

  &__documents {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
    align-items: center;
    width: 100%;
    height: 48px;
    color: $dark;
    font-size: 14px;
    font-weight: 400;
    line-height: 16.94px;
    cursor: pointer;

    &:not(:last-child) {
      margin-bottom: 20px;
    }
  }

  &__responsible-text {
    display: flex;
    align-items: center;
    flex: 1 1 auto;
    height: 48px;
    padding-left: 16px;
    background-color: $light;
    border-radius: 8px;
  }

  &__responsible-text-name {
    flex: 1 1 20%;
    font-size: 14px;
    font-weight: 400;
    line-height: 16.94px;
  }

  &__vacancy-name {
    flex: 1 1 20%;
    font-size: 14px;
    font-weight: 500;
    line-height: 16.94px;
  }
}
</style>